import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppTypeEnum } from 'src/app/model/appType';
import { ThemeService } from 'src/app/services/theme.service';
import { GlobalStateService } from '../../../services/globalState.service';
import { DrawerService } from '../../../services/drawer.service';

@Component({
    selector: 'app-home-qualificates',
    templateUrl: './home-qualificates.component.html',
    styleUrls: ['./home-qualificates.component.scss'],
    standalone: false,
})
export class HomeQualificatesComponent implements OnInit {

  roouterPath: boolean;

  constructor(
    private router: Router,
    private themeService: ThemeService,
    private globalStateService: GlobalStateService,
    private drawerService: DrawerService,
  ) { }

  ngOnInit(): void {
    this.drawerService.close();
  }

  getTheme(): string {
    return this.themeService.getThemeHome(AppTypeEnum.QUALIFICATES);
  }

  goToPage(page: string): void {
    this.roouterPath = true;
    void this.router.navigateByUrl(page);
    
  }

  getLogo(): string {
    return 'assets/img/qloud_qualificates.png';
  }

  getText(): string {
    return 'landing.main.qualificates';
  }

  newProtocolqualificates(): void {
    void this.router.navigateByUrl('/qualificates/protocol?id=0');
  }

  newExecutionqualificates(): void {
    void this.router.navigateByUrl('/qualificates/execution?id=0');
  }

  navigateToQualificatesOptions(url: string): void {
    this.roouterPath = true;
    const newState = { selectedOption: 'qualificates-'+url };
    this.globalStateService.updateTabState('main-tab', newState);
    void this.router.navigate(['qualificates',url]);
  }


}
